{
  "externalShare.title": "Review shared content",
  "externalShare.description": "Nothing is added to your account until you review it and choose Import.",
  "externalShare.loading": "Opening the content shared to Exognitos…",
  "externalShare.loadError": "The shared content could not be opened on this device.",
  "externalShare.preserved": "Your pending share has been kept so you can try again.",
  "externalShare.sharedContent": "Shared content",
  "externalShare.sharedTitle": "Title",
  "externalShare.sharedText": "Text",
  "externalShare.sharedUrl": "URL",
  "externalShare.files": "Files",
  "externalShare.filesDescription": "These exact files will be attached to the new Draft after its upload checks pass.",
  "externalShare.unknownFileType": "Unknown file type",
  "externalShare.fileSizeBytes": "{{value}} B",
  "externalShare.fileSizeKilobytes": "{{value}} KB",
  "externalShare.fileSizeMegabytes": "{{value}} MB",
  "externalShare.filesUnavailable": "File uploads are not available right now. The share will stay on this device.",
  "externalShare.progress": "Attached {{completed}} of {{total}} files.",
  "externalShare.keepForLater": "Keep for later",
  "externalShare.import": "Import as Draft",
  "externalShare.success": "Shared content saved as a Draft",
  "externalShare.empty": "Nothing is waiting for review",
  "externalShare.emptyDescription": "Share text, a link, a photo, or a document to Exognitos from another app.",
  "externalShare.openDrafts": "Open Drafts",
  "externalShare.reauthorizeFiles": "This Android authorization predates file sharing. Sign out and sign in again, then retry; your pending share will stay on this device.",
  "externalShare.submitError": "The shared content could not be imported."
}
